module.exports = __webpack_public_path__ + "img/tech1.004f925d.png";